<template>
  <div class="user-info">
    <div
  class="avatar"
  :style="!hasImage ? { backgroundColor } : {}"
>
      <img
        v-if="hasImage"
        :src="imageUrl"
        alt="User Avatar"
      />
      <span v-else>{{ initials }}</span>
    </div>

    <span class="fullname text-sm text-color">
      {{ fullName }}
    </span>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  fullName: {
    type: String,
    required: true,
  },
  imageUrl: {
    type: String,
    default: "",
  },
});

const hasImage = computed(() => {
  return props.imageUrl && props.imageUrl.trim() !== "";
});

const initials = computed(() => {
  const words = props.fullName.trim().split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
});

const backgroundColor = computed(() => {
  let hash = 0;
  for (let i = 0; i < props.fullName.length; i++) {
    hash = props.fullName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 45%)`;
});
</script>

<style scoped>
.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Inter", sans-serif;
}

.avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar span {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>